<div class="topHead">
    <h2>Organisation Management</h2>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Organisation Management</h2> 
    </div>
<div class="adminTabWrap">
    <div class="filterWrap">

        <div class="searchWrap">
            <input type="text" placeholder="Search by Organisation" #searchOrg/>
        </div>
        <a href="javascript:void(0);" [routerLink]="['/organisation_create']" class="btn btn-primary btn-sm" >+ Create New Organisation</a>
    </div>
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onSelectChange($event)">
        <mat-tab label="Active" (click)="getOrganisationList('',1,'created_dttm','DESC')">
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div  mat-sort-header="org_name"><b></b> Organisations</div></th>
                            <th><div mat-sort-header="org_type"><b></b> Type</div></th>
                            
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="selectTr" *ngFor="let values of organisationData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                    <a class="btn-link"> <span>{{values.org_name}}</span></a>
                                    <b>{{values.created_dttm}}</b>
                                </div>
                            </td>
                             
                            <td>{{values.org_type}}</td>
                            <td>
                                <ul class="userActionBtn">
                                    <li class="w-auto"><a href="javascript:void(0);" class="btn-link second-link"  (click)="edit(values.organisation_id)">EDIT</a></li>
                                    <li class="w-auto"><a href="javascript:void(0);" class="btn-link second-link" (click)="open(deactivate,values.organisation_id,'Active')">DEACTIVATE</a></li>
                                    <li class="w-auto"><a href="javascript:void(0);" class="btn-link second-link" (click)="open(delete,values.organisation_id,'Active')">DELETE</a></li>

                                   
                                </ul>
                            </td>
                        </tr>
                     
                    </tbody>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Deactivated"  (click)="getOrganisationList('',0,'created_dttm','DESC')">
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="org_name"><b></b> Organisations</div></th>
                            <th><div mat-sort-header="created_dttm"><b></b> Type</div></th>
                            
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="selectTr" *ngFor="let values of organisationData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                   <a class="btn-link"> <span>{{values.org_name}}</span></a>
                                    <b>{{values.created_dttm}}</b>
                                </div>
                            </td>
                             
                            <td>{{values.org_type}}</td>
                            <td>
                                <ul class="userActionBtn">
                                     
                                    <li><a href="javascript:void(0);" class="btn-link-green" (click)="open(active,values.organisation_id,'Deactivated')">ACTIVATE</a></li>
                                   
                                    

                                </ul>
                            </td>
                        </tr>
                     
                    </tbody>
                </table>
            </div>

        </mat-tab>
         
      </mat-tab-group>

</div>

</div>
<ngx-spinner><p style="color: white" > Loading... </p></ngx-spinner>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate organisation</h6>
                <p class="size18">Are you sure want to deactivate this organization?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(organisation_id,0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #active let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate organisation</h6>
                <p class="size18">Are you sure want to activate this organisation?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsActiveVal(organisation_id,1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #delete let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete Organisation capsule</h6>
                <p class="size18">Are you sure you want to Delete this Organisation?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="deleteOrganisation(organisation_id)">Yes, Delete</a>
            </div>
        </div>
    </div>
</ng-template>

